import React from 'react';

const DocumentHistoryMonthHeader = ({ monthLabel, entryCount }) => (
  <div className="sticky top-0 z-[5] bg-flexi-history-page-bg pt-4 pb-2">
    <div className="flex items-center gap-3">
      <span className="text-flexi-primary-color font-extrabold text-lg whitespace-nowrap">
        {monthLabel}
      </span>
      <div className="flex-1 h-px bg-flexi-primary-color" />
      <span className="text-flexi-grey font-semibold text-medium whitespace-nowrap">
        {entryCount} {entryCount > 1 ? 'entrées' : 'entrée'}
      </span>
    </div>
  </div>
);

export default DocumentHistoryMonthHeader;
